import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { PaginationComponent } from './pagination/pagination.component';
import { ModalAudioReportComponent } from './modal-audio-report/modal-audio-report.component';
import { LoadingComponent } from './loading/loading.component';


@NgModule({
  declarations: [HeaderComponent, PaginationComponent, ModalAudioReportComponent, LoadingComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    HeaderComponent,
    PaginationComponent,
    ModalAudioReportComponent,
    LoadingComponent
  ]
})
export class GlobalComponentsModule { }
